/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeARightIcon20Regular = forwardRef('ArrowShapeARightIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.772 8.41a2.25 2.25 0 0 1 0 3.18l-6.967 6.977c-.85.852-2.306.25-2.306-.954V14.75H4a2 2 0 0 1-2-2v-5.5a2 2 0 0 1 2-2h4.5V2.388c0-1.203 1.456-1.805 2.306-.954l6.967 6.977Zm-1.062 2.12a.75.75 0 0 0 0-1.06L10 2.75V6a.75.75 0 0 1-.75.75H4a.5.5 0 0 0-.5.5v5.5a.5.5 0 0 0 .5.5h5.25A.75.75 0 0 1 10 14v3.25l6.71-6.72Z" })));
});
